import React from 'react';
import styled from 'styled-components'
import Utils from './Utils'
import ActorSession from './ActorSession'
import PageWrapper from './PageWrapper';


import { InputFields, SessionForm, SessionTextArea, NumberTextArea, FormField, SubmitRow } from './Components'


class SessionSpec extends React.Component {
    constructor(props) {
      super(props);
      this.handler = this.handler.bind(this);
      this.focus = this.focus.bind(this);
      this.textInput = React.createRef();
      this.state = {
        submitting: false,
        response: this.props.output,
        finalised: false,
        name: '',
        premise: '',
        example_caller_scene: '',
        example_agent_scene: '',
        instructions: '',
        priority: 0,
        num_convs_required: -1,
        flexibility: 1,
        generated_caller_scene: null,
        generated_agent_scene: null,
        error: '',
      };
    }

    componentDidMount(){}

    componentDidUpdate(){}

    onSubmit(e) {
      if (this.state.submitting) return;
      e.preventDefault();
      e.stopPropagation();
      let data = new FormData(e.target);

      data.append("name", this.state.name);
      data.append("premise", this.state.premise);
      data.append("example_caller_scene", this.state.example_caller_scene);
      data.append("example_agent_scene", this.state.example_agent_scene);
      data.append("priority", this.state.priority);
      data.append('finalised', this.state.finalised);
      Utils.apiPost("/actor/new_session_spec", data)
        .then((response) => {
          this.setState({
            generated_caller_scene: response.data.generated_caller_scene,
            generated_agent_scene: response.data.generated_agent_scene,
          });
        })
        .catch((e) => {
          if (e.response && e.response.data) {
            this.setState({
              error: e.response.data["message"],
            });
          }
        })
        .finally((x) => this.setState({ submitting: false }));
    }
  
    handler(e) {
      this.setState({
        prompt: e,
      });
    }
  
    focus(start, end) {
      if (document.activeElement != this.textInput.current) {
        this.textInput.current.focus();
        console.log(start, end);
        this.textInput.current.setSelectionRange(start, end);
      }
    }
  
    render() {
        let example_scenes = 
            <div>
                <h1>Example of Caller Page: </h1>
                <ActorSession
                    debug={true}
                    role={'caller'}
                    sessionPremise={this.state.premise}
                    agentScene={this.state.generated_agent_scene}
                    callerScene={this.state.generated_caller_scene}
                    instructions={this.state.instructions}
                    flexibility={this.state.flexibility}
                />
                <h1>Example of Agent Page: </h1>
                <ActorSession
                    debug={true}
                    role={'agent'}
                    sessionPremise={this.state.premise}
                    agentScene={this.state.generated_agent_scene}
                    callerScene={this.state.generated_caller_scene}
                    instructions={this.state.instructions}
                    flexibility={this.state.flexibility}
                />
            </div>

      return (
        <PageWrapper isAdmin={this.props.isAdmin} style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SessionForm key="session" onSubmit={this.onSubmit.bind(this)}>
              <InputFields>
                <FormField label="Name" error={this.state.error}>
                  <SessionTextArea
                    name="name"
                    placeholder="name"
                    onChange={(x) => this.setState({ name: x.target.value })}
                    value={this.state.name}
                    ref={this.textInput}
                  />
                </FormField>
                <FormField label="Premise" error={this.state.error}>
                  <SessionTextArea
                    name="premise"
                    placeholder="premise"
                    onChange={(x) => this.setState({ premise: x.target.value })}
                    value={this.state.premise}
                    ref={this.textInput}
                  />
                </FormField>
                <FormField label="Example Caller Scene" error={this.state.error}>
                  <SessionTextArea
                    name="example_caller_scene"
                    placeholder="Write an example of a Caller scene"
                    onChange={(x) => this.setState({ example_caller_scene: x.target.value })}
                    value={this.state.example_caller_scene}
                    ref={this.textInput}
                  />
                </FormField>
                <FormField label="Example Agent Scene" error={this.state.error}>
                  <SessionTextArea
                    name="example_agent_scene"
                    placeholder="Write an example of an Agent scene"
                    onChange={(x) => this.setState({ example_agent_scene: x.target.value })}
                    value={this.state.example_agent_scene}
                    ref={this.textInput}
                  />
                </FormField>
                <FormField label="Additional Instructions for the Actors" error={this.state.error}>
                  <SessionTextArea
                    name="instructions"
                    placeholder=""
                    onChange={(x) => this.setState({ instructions: x.target.value })}
                    value={this.state.instructions}
                    ref={this.textInput}
                  />
                </FormField>
                <div>
                  <FormField label="priority">
                    <NumberTextArea
                      name="priority"
                      type="number"
                      placeholder="priority"
                      onChange={(x) => this.setState({ priority: x.target.value })}
                      value={this.state.priority}
                      min="0"
                      max="5"
                      step="1"
                    />
                  </FormField>
                  <FormField label="num_convs_required">
                    <NumberTextArea
                      name="num_convs_required"
                      type="number"
                      placeholder="Number of Conversations"
                      onChange={(x) =>
                        this.setState({ num_convs_required: x.target.value })
                      }
                      value={this.state.num_convs_required}
                    />
                  </FormField>
                  <FormField label="Flexibility">
                    <NumberTextArea
                      name="flexibility"
                      type="number"
                      placeholder="0 means your example scripts will be used exactly as is, up to 5 for maximal flexibility"
                      onChange={(x) =>
                        this.setState({ flexibility: x.target.value })
                      }
                      value={this.state.flexibility}
                    />
                  </FormField>
                </div>
                <SubmitRow>
                  <button disabled={this.state.submitting} type="submit" name="generate">
                    Generate Examples
                  </button>
                  <button disabled={this.state.submitting || !this.state.generated_caller_scene} type="submit" name="finalise" onClick={() => this.setState({finalised: true})}>
                    Submit Finalised Session Spec
                  </button>
                  {this.state.submitting && <SpinnerIcon />}
                  {this.state.error}
                </SubmitRow>
              </InputFields>
            </SessionForm>
            {this.state.generated_caller_scene && example_scenes}
          </div>
        </PageWrapper>
      );
    }
  }


export default SessionSpec